import PropTypes from 'prop-types';
import "./RadioButton.scss";

/**
 * RadioButton component for rendering radio button options.
 *
 * @param {string} name - The name of the radio group.
 * @param {function} onChange - Callback function to handle change events.
 * @param {function} onBlur - Callback function to handle blur events.
 * @param {object} formSetting - Configuration object for form settings.
 * @param {Array} options - Array of radio button options.
 * @param {string} selectedOption - The currently selected option value.
 * @param {string} radioId - The ID of the radio button (for single radio button).
 * @param {boolean} isChecked - Whether the single radio button is checked.
 * @param {string} radioName - The name of the single radio button (for single radio button).
 * @param {string} valueName - The value of the single radio button (for single radio button).
 */
const RadioButton = ({
  name,
  onChange,
  onBlur,
  formSetting,
  options,
  value,
  radioId,
  isChecked,
  radioName,
  valueName,
  ...fieldSetting
}) => {

  const handleRadioChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <>
      {options
        ? (
          <div className={`radio-buttons-wrapper ${fieldSetting.wrapperClassName || ""}`}>
            {options.map((option) => (
              <div className={`radio-buttons ${option.optionClass || ""}`} key={option.value}>
                <input type="radio" id={`${name}-${option.value}`}
                  name={name} value={String(option.value)} checked={String(value) === String(option.value)}
                  onChange={handleRadioChange} onBlur={onBlur}
                  disabled={formSetting?.isViewOnly || fieldSetting.isDisable || option.isDisable || false} />
                <label className="radio-label" htmlFor={`${name}-${option.value}`}>
                  <span className="radio-custom"></span>
                  <span className="radio-content">
                    <span className="radio-title">{option.label}</span>
                    {option.description && (
                      <span className="radio-desc">{option.description}</span>
                    )}
                  </span>
                </label>
              </div>
            ))}
          </div>
        )
        : (
          <div className="radio">
            <input
              id={radioId}
              type="radio"
              className="form-radio"
              name={radioName}
              checked={isChecked}
              value={valueName}
              onChange={onChange} />
            <label htmlFor={radioId} className="radio-label">{valueName}</label>
          </div>
        )
      }
    </>
  );
}

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  formSetting: PropTypes.shape({
    isViewOnly: PropTypes.bool
  }),
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      optionClass: PropTypes.string,
      isDisable: PropTypes.bool
    })
  ),
  selectedOption: PropTypes.string,
  radioId: PropTypes.string,
  isChecked: PropTypes.bool,
  radioName: PropTypes.string,
  valueName: PropTypes.string
};

export default RadioButton;
